import { message } from 'antd'


export const errorNotification = (textToShow, duration = 5) => {
    return message.error(textToShow, duration)
  }

  export const successNotification = (textToShow, duration = 5) => {
    return message.success(textToShow, duration)
  }
